// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
// 导入不需要懒加载的首屏组件
import HomeView from '../views/HomeView.vue'
import ProductView from '../views/ProductView.vue'
import SolutionsView from '../views/SolutionsView.vue'
import SupportView from '../views/SupportView.vue'
import ContactView from '../views/ContactView.vue'
import ControlPanelView from '@/views/software/ControlPanelView.vue'
import CmsView from '@/views/software/CmsView.vue'

// 1. 定义路由表
const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomeView
    },
    {
        path: '/products',
        name: 'Products',
        component: ProductView
    },
    {
        path: '/solutions',
        name: 'Solutions',
        component: SolutionsView
    },
    {
        path: '/support',
        name: 'Support',
        component: SupportView
    },
    {
        path: '/contact',
        name: 'Contact',
        component: ContactView
    },
    {
        path: '/software/controlPanel',
        name: 'ControlPanel',
        component: ControlPanelView
    },
    {
        path: '/software/cms',
        name: 'Cms',
        component: CmsView
    },
]

// 2. 创建路由实例
const router = createRouter({
    // 使用 HTML5 模式（去除 URL 中的 # 号）
    history: createWebHistory(),
    routes,
    // 可选：每次切换路由时让页面滚动到顶部
    scrollBehavior() {
        return { top: 0 }
    }
})

export default router